import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

export const getMockResources = bgColor => {
  // eslint-disable-next-line no-param-reassign
  bgColor = bgColor || "102641";
  return ([{
    resourceId: 'card-skeleton-1',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-2',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-3',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-4',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-5',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-6',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-7',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-8',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-9',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-10',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-11',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }, {
    resourceId: 'card-skeleton-12',
    resourceType: 'mock',
    bgColor:
      ([colorPalette.jet.main, colorPalette.lapis.main, colorPalette.lapis.light, colorPalette.lapis.medium].includes(bgColor) ||
      !["#FEFEFE", "#FFFFFF", "transparent"].includes(bgColor)) ?
        colorPalette.turquiose[300] :
        colorPalette.neutral[300]
  }])
};
